import {AxiosService} from './axiosService';

export class ReportService extends AxiosService {
  async getReports(pageSize, pageIndex, sortField, sortDirection, customerId) {
    try {
      const {data} = await this.axios.get('/reports', {
        params: {
          pageSize: pageSize,
          pageIndex: pageIndex,
          sortBy: sortField,
          orderBy: sortDirection,
          customerId: customerId,
        },
      });
      return data;
    } catch (e) {
      // if the status code is a 401 we do NOT want to throw
      if (e?.response?.status !== 401) {
        throw e;
      }
    }
    return null;
  }

  async getEquipment(pageSize, pageIndex, sortField, sortDirection, customerId) {
    try {
      const {data} = await this.axios.get('/equipment', {
        params: {
          pageSize: pageSize,
          pageIndex: pageIndex,
          sortBy: sortField,
          orderBy: sortDirection,
          customerId: customerId,
        },
      });
      return data;
    } catch (e) {
      // if the status code is a 401 we do NOT want to throw
      if (e?.response?.status !== 401) {
        throw e;
      }
    }
    return null;
  }

  async getAosComponents(rootComponentId) {
    try {
      const {data} = await this.axios.post('/aosComponents', {RootComponentId: rootComponentId});
      return data;
    } catch (e) {
      // if the status code is a 401 we do NOT want to throw
      if (e?.response?.status !== 401) {
        throw e;
      }
    }
    return null;
  }

  async getComponentChildren(rootComponentId) {
    try {
      const {data} = await this.axios.get(`/componentChildren?parentId=${rootComponentId}`);
      return data;
    } catch (e) {
      // if the status code is a 401 we do NOT want to throw
      if (e?.response?.status !== 401) {
        throw e;
      }
    }
    return null;
  }

  componentsExport(componentId) {
    try {
      return this.axios({
        method: "get",
        url: `/ComponentsExport?ComponentId=${componentId}`,
        responseType: "blob"
      });
    } catch (e) {
      // if the status code is a 401 we do NOT want to throw
      if (e?.response?.status !== 401) {
        throw e;
      }
    }
    return null;
  }

  async componentsImport(file) {
    try {
      const {data} = await this.axios.post('/ComponentsImport', file);
      return data;
    } catch (e) {
      // if the status code is a 401 we do NOT want to throw
      if (e?.response?.status !== 401) {
        throw e;
      }
    }
    return null;
  }

  async createReport(
    reportName,
    reportYear,
    reportStartMonth,
    reportEndMonth,
    benchmarkYear,
    benchmarkStartMonth,
    benchmarkEndMonth,
    electricRate,
    gasRate,
    gasUnit,
    equipmentIds,
    customerId,
    templateId
  ) {
    try {
      const {data} = await this.axios.post('/reports', {
        reportName,
        reportYear,
        reportStartMonth,
        reportEndMonth,
        benchmarkYear,
        benchmarkStartMonth,
        benchmarkEndMonth,
        electricRate,
        gasRate,
        gasUnit,
        equipmentIds,
        customerId,
        templateId,
      });

      return data;
    } catch (e) {
      // if the status code is a 401 we do NOT want to throw
      if (e?.response?.status !== 401) {
        throw e;
      }
    }
    return null;
  }

  async getReportTemplate(id) {
    try {
      const {data} = await this.axios.get(`/reports/getreporttemplate?id=${id}`);
      return data;
    } catch (e) {
      // if the status code is a 401 we do NOT want to throw
      if (e?.response?.status !== 401) {
        console.error(e);
        throw e;
      }
    }
    return null;
  }

  async getReportTemplates(reportsOnly = false) {
    try {
      const {data} = await this.axios.get(`/reports/getreporttemplates?reportsOnly=${reportsOnly}`);
      return data.templates;
    } catch (e) {
      // if the status code is a 401 we do NOT want to throw
      if (e?.response?.status !== 401) {
        console.error(e);
        throw e;
      }
    }
    return null;
  }

  async getReportMetric(id, type) {
    try {
      const {data} = await this.axios.get(`/reports/getreportmetric?id=${id}&type=${type}`);
      return data;
    } catch (e) {
      // if the status code is a 401 we do NOT want to throw
      if (e?.response?.status !== 401) {
        console.error(e);
        throw e;
      }
    }
    return null;
  }

  async getGenericPoints(pageSize, pageIndex, sortBy, orderBy, pointType) {
    try {
      const {data} = await this.axios.get(
        `/reports/getgenericpoints?pageSize=${pageSize}&pageIndex=${pageIndex}&sortBy=${sortBy}&orderBy=${orderBy}&pointType=${pointType}`
      );
      return data;
    } catch (e) {
      // if the status code is a 401 we do NOT want to throw
      if (e?.response?.status !== 401) {
        console.error(e);
        throw e;
      }
    }
    return null;
  }

  async upsertReportTemplateMetric(formData) {
    try {
      const {data} = await this.axios.post(`/reports/template/metric`, formData);
      return data;
    } catch (e) {
      // if the status code is a 401 we do NOT want to throw
      if (e?.response?.status !== 401) {
        console.error(e);
        throw e;
      }
    }
    return null;
  }

  async deleteReportTemplate(id) {
    try {
      const {data} = await this.axios.delete(`/reports/template?TemplateId=${id}`);
      return data;
    } catch (e) {
      // if the status code is a 401 we do NOT want to throw
      if (e?.response?.status !== 401) {
        console.error(e);
        throw e;
      }
    }
    return null;
  }

  async deleteReportTemplateMetric(id, type) {
    try {
      const {data} = await this.axios.delete(
        `/reports/template/metric?MetricId=${id}&MetricType=${type}`
      );
      return data;
    } catch (e) {
      // if the status code is a 401 we do NOT want to throw
      if (e?.response?.status !== 401) {
        console.error(e);
        throw e;
      }
    }
    return null;
  }

  async updateReportTemplateMetricIndex(id, type, moveUp) {
    try {
      const {data} = await this.axios.put(
        `/reports/template/metric/index?MetricId=${id}&MetricType=${type}&MoveUp=${moveUp}`
      );
      return data;
    } catch (e) {
      // if the status code is a 401 we do NOT want to throw
      if (e?.response?.status !== 401) {
        console.error(e);
        throw e;
      }
    }
    return null;
  }

  async createNewReportTemplate(name, isApiOnly) {
    try {
      const {data} = await this.axios.post(`/reports/template`, {name, isApiOnly});
      return data.id;
    } catch (e) {
      // if the status code is a 401 we do NOT want to throw
      if (e?.response?.status !== 401) {
        console.error(e);
        throw e;
      }
    }
    return null;
  }

  async updateReportTemplate(id, name, isApiOnly) {
    try {
      const {data} = await this.axios.put(`/reports/template`, {id, name, isApiOnly});
      return data.id;
    } catch (e) {
      // if the status code is a 401 we do NOT want to throw
      if (e?.response?.status !== 401) {
        console.error(e);
        throw e;
      }
    }
    return null;
  }

  async createSyrxReport(reportName, customerId, groupId, equipmentIds) {
    try {
      const {data} = await this.axios.post(`/GenerateSyrxReport`, {
        ReportName: reportName,
        CustomerId: customerId,
        GroupId: groupId,
        IncludedComponents: equipmentIds,
      });
      return data.id;
    } catch (e) {
      // if the status code is a 401 we do NOT want to throw
      if (e?.response?.status !== 401) {
        console.error(e);
        throw e;
      }
    }
    return null;
  }
}

export const reportService = new ReportService();
